import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showTiles: true,
    isActiveChat: false,
    selectedTileId: null,
    selectedPromptItem: null,
    promptBar: {},
    promptItems: [],
    loading: false,
    isDarkTheme: false,
    toast: {
        open: false,
        message: '',
        severity: ''
    }
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setShowTiles(state, action) {
            state.showTiles = action.payload;
        },
        setIsActiveChat(state, action) {
            state.isActiveChat = action.payload;
        },
        setSelectedTileId(state, action) {
            state.selectedTileId = action.payload;
        },
        clearSelectedTileId(state) {
            state.selectedTileId = null;
        },
        // New actions for prompt items
        addPromptItem(state, action) {
            state.promptItems.push(action.payload);
        },
        removePromptItem(state, action) {
            state.promptItems = state.promptItems.filter(item => item.id !== action.payload);
        },
        updatePromptItem(state, action) {

            const { id, updates } = action.payload;
            const index = state.promptItems.findIndex(item => item.id === id);
            if (index !== -1) {
                state.promptItems[index] = { ...state.promptItems[index], ...updates };
            }
        },
        reorderPromptItems(state, action) {
            state.promptItems = action.payload;
        },
        // New action to clear all prompt items
        clearPromptItems(state) {
            state.promptItems = [];
        },
        // New action to set the selected prompt item
        setSelectedPromptItem(state, action) {
            state.selectedPromptItem = action.payload;
        },
        //Clear selected prompt item
        clearSelectedPromptItem(state) {
            state.selectedPromptItem = null;
        },
        // New actions for toast
        showToast: (state, action) => {

            const { message, severity } = action.payload;
            state.toast.open = true;
            state.toast.message = message;
            state.toast.severity = severity;
        },

        hideToast: (state) => {
            state.toast.open = false;
            state.toast.message = '';
            state.toast.severity = '';
        },

        setPromptBarActive: (state, action) => {
            state.isPromptBarActive = action.payload;
        },
        setIsDarkTheme: (state, action) => {
            console.log(action.payload)
            state.isDarkTheme = action.payload;

            // Save the theme preference to local storage
            if (action.payload === true) {
                localStorage.setItem('theme', 'dark');
            } else {
                localStorage.removeItem('theme');
            }
        },
    },
});

export const {
    setShowTiles,
    setIsActiveChat,
    setSelectedTileId,
    clearSelectedTileId,
    addPromptItem,
    removePromptItem,
    updatePromptItem,
    reorderPromptItems,
    clearPromptItems,
    setSelectedPromptItem,
    clearSelectedPromptItem,
    showToast,
    hideToast,
    setIsDarkTheme,

    setPromptBarActive
} = uiSlice.actions;

export default uiSlice.reducer;

// Selector to get all prompt items
export const selectedPromptItem = (state) => state.ui.selectedPromptItem;

